interface ReaderSettingsProps {
  width: string;
  theme: string;
  scale: string;
  onWidth: (v: string) => void;
  onTheme: (v: string) => void;
  onScale: (v: string) => void;
}

const widths = [
  { key: 'narrow', label: '窄' },
  { key: 'normal', label: '标准' },
  { key: 'wide', label: '宽' },
];

const themes = [
  { key: 'day', label: '日间' },
  { key: 'sepia', label: '护眼' },
  { key: 'night', label: '夜间' },
];

const scales = [
  { key: 'small', label: '小' },
  { key: 'medium', label: '中' },
  { key: 'large', label: '大' },
];

function Row({
  label,
  options,
  value,
  onChange,
}: {
  label: string;
  options: { key: string; label: string }[];
  value: string;
  onChange: (v: string) => void;
}) {
  return (
    <div>
      <p className="mb-2 text-xs text-foreground-500">{label}</p>
      <div className="flex gap-2">
        {options.map((o) => (
          <button
            key={o.key}
            type="button"
            onClick={() => onChange(o.key)}
            className={`flex-1 whitespace-nowrap rounded-md px-3 py-2 text-xs transition-colors cursor-pointer ${
              value === o.key
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-700 hover:bg-background-200'
            }`}
          >
            {o.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function ReaderSettings(props: ReaderSettingsProps) {
  const { width, theme, scale, onWidth, onTheme, onScale } = props;
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-3">
      <Row label="阅读宽度" options={widths} value={width} onChange={onWidth} />
      <Row label="背景模式" options={themes} value={theme} onChange={onTheme} />
      <Row label="图片大小" options={scales} value={scale} onChange={onScale} />
    </div>
  );
}